<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="teacherAssignForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Practical Examiner Assignment Data
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Practical Examiner Assignment
                        </p>
                    </div>
                </div>
                <!-- <div class="bc d-flex align-items-center pl-3" *ngIf="updateButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Teachers Data
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Update Teachers Data
                        </p>
                    </div>
                </div> -->
                <!-- <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Teachers Data
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Delete Teachers Data
                        </p>
                    </div>
                </div> -->
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Request Type</mat-label>
                            <mat-select formControlName="ReqType" #select3904 placeholder="Request Type"
                                class="colorblack">
                                <mat-select-filter *ngIf="select3904.focused" [placeholder]="'Request Type'"
                                    [displayMember]="'CdCode'" [array]="requestTypeList"
                                    (filteredReturn)="filteredrequestTypeList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredrequestTypeList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['ReqType'].touched && teacherAssignForm.controls['ReqType'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Session</mat-label>
                            <mat-select #select232 placeholder="Session" class="colorblack" formControlName="SessionId"
                                required>
                                <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                    [displayMember]="'SnName'" [array]="sessionList"
                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                    {{item.SnName}}
                                </mat-option>
                            </mat-select>
                            <!-- <mat-error class="margin_tp"
                                *ngIf="deptSubMappingForm.controls['DmSnNo'].touched && deptSubMappingForm.controls['DmSnNo'].errors?.required">
                                Mandatory
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Course</mat-label>
                            <mat-select #select122 placeholder="Course" formControlName="CoCode" required>
                                <mat-select-filter *ngIf="select122.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredListCourse =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode"
                                    (click)="getsubjects(item.CoCode)">
                                    {{item.CoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Subject</mat-label>
                            <mat-select #select123 placeholder="CoCode" class="colorblack" formControlName="SubCode"
                                required>
                                <mat-select-filter *ngIf="select123.focused" [placeholder]="'Filter'"
                                    [displayMember]="'EsName'" [array]="subjectList"
                                    (filteredReturn)="filteredsubjectList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredsubjectList" [value]="item.EsId"
                                    (click)="getCount(item)">
                                    {{item.EsName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Student Count</mat-label>
                            <input maxlength="150" matInput formControlName="count">
                        </mat-form-field>
                    </div>
                    <div style="display:none;" class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Notes</mat-label>
                            <input maxlength="150" matInput formControlName="Notes">
                        </mat-form-field>
                    </div>
                    <div style="color: red;font-weight: bold; margin-left: 1px;" class="col-sm-12 row">
                        {{publishMessage}}
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                            <button *ngIf="publishBtn" id="Publish" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="Publish()"
                                [disabled]="disableSendNotifications">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Send Notifications
                                </span>
                            </button>
                            <button *ngIf="PETeacher" id="AcceptAll" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1 mr-2"
                                (click)="acceptAllExaminers()" [disabled]="disableAcceptAll">
                                <span style="display: contents; align-items: center;">
                                    <i class="fas fa-check-double" style="margin-right: 5px;"></i>
                                    Accept All
                                </span>
                            </button>
                            <button *ngIf="PETeacher" id="SendEmail" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1 mr-2" (click)="sendEmail()">
                                <span style="display: contents; align-items: center;">
                                    <i class="fas fa-envelope" style="margin-right: 5px;"></i>
                                    Send Email
                                </span>
                            </button>
                            <button *ngIf="PETeacher && !isFinalListMode && allProvisionalAccepted" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1 mr-2"
                                (click)="isFinalListMode = true; getTeachersData()">
                                <i class="fas fa-list-ul"></i> Final Reassign List
                            </button>
                            <button *ngIf="PETeacher && isFinalListMode && !allProvisionalAccepted" type="button"
                                class="btn btn-primary btn-icon-text floatright mt-1 mr-2"
                                (click)="isFinalListMode = false; getTeachersData()">
                                <i class="fas fa-undo-alt"></i> Show Provisional List
                            </button>
                        </div>
                    </div>
                    <div *ngIf="PETeacher" id="msg">
                        {{ isFinalListMode ? 'Final Examiners List' : 'Provisional Examiners List' }}
                    </div>
                    <hr class="mt-1">
                    <div *ngIf="PETeacher" class="table-responsive table-container">
                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th class="f600 text-center hidden" width="5%"> Teacher Id </th>
                                    <th class="f600 text-left" width="5%"> Examiner Name </th>
                                    <th class="f600 text-left" width="10%"> Mobile No </th>
                                    <th class="f600 text-left" width="10%"> Home College </th>
                                    <th class="f600 text-left" width="10%"> Assigned College </th>
                                    <th class="f600 text-left hidden" width="10%"> Assigned College Code </th>
                                    <th class="f600 text-left" width="15%"> Assigned For </th>
                                    <!-- <th class="f600 text-left" width="10%"> Availability </th> -->
                                    <!-- <th class="f600 text-left" width="10%"> Re-Provisional </th> -->
                                    <th class="f600 text-left" width="15%"> Acceptance Status </th>
                                    <th class="f600 text-left" width="12%"> Pro. Reassign </th>
                                    <th class="f600 text-left" width="10%"> Re-Assign(auto) </th>
                                    <th *ngIf="isFinalListMode" class="f600 text-left" width="12%"> Final Reassign </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="intExternalTeaArray">
                                <tr *ngFor="let subject of getControlsIntExternal(); let i = index "
                                    [formGroupName]="i">
                                    <td class="text-left hidden">{{ subject.get('TeacherId').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('TeacherName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('MobileNo').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('CollegeName').value }}
                                    </td>
                                    <td class="text-left">
                                        {{ subject.get('AssignClg').value }}
                                    </td>
                                    <td class="text-left hidden">
                                        {{ subject.get('AssignClgCode').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('AssignFor').value }}
                                    </td>
                                    <!-- <td class="text-left">{{ subject.get('Availability').value == 1 ? 'Accept' :
                                        subject.get('Availability').value == 0 ? 'Reject' : 'No Response' }}
                                    </td> -->
                                    <!--<td class="text-center">
                                        <i (click)="ReProvisional(subject)" class="fa fa-edit" style="cursor: pointer;"></i>
                                        <i *ngIf="subject.get('AcceptStatus').value != 0" class="fa fa-edit text-muted"
                                            style="pointer-events: none; opacity: 0.5;"></i> 
                                    </td>-->
                                    <td class="text-left">{{ subject.get('AcceptStatus').value == 1 ? 'Accept' :
                                        subject.get('AcceptStatus').value == 0 ? 'Reject' : 'No Response' }}
                                    </td>
                                    <td class="text-center">
                                        <i (click)="openManualReassign(subject)"
                                            *ngIf="subject.get('AcceptStatus').value == -1 && subject.get('Availability').value == 1"
                                            class="fa fa-edit" style="cursor: pointer;"
                                            title="Manually reassign this examiner"></i>

                                        <i *ngIf="!(subject.get('AcceptStatus').value == -1 && subject.get('Availability').value == 1)"
                                            class="fa fa-edit text-muted" style="pointer-events: none; opacity: 0.5;"
                                            title="Manual reassign not allowed"></i>
                                    </td>
                                    <td class="text-center">
                                        <i (click)="ReAssign(subject)" *ngIf="subject.get('AcceptStatus').value == 0"
                                            class="fa fa-edit" style="cursor: pointer;"></i>
                                        <i *ngIf="subject.get('AcceptStatus').value != 0" class="fa fa-edit text-muted"
                                            style="pointer-events: none; opacity: 0.5;"></i>
                                    </td>
                                    <td *ngIf="isFinalListMode" class="text-center">
                                        <i (click)="openReassignFinal(subject)"
                                            *ngIf="subject.get('AcceptStatus').value == 1" class="fa fa-edit"
                                            style="cursor: pointer;" title="Reassign final examiner"></i>
                                        <i *ngIf="subject.get('AcceptStatus').value != 1" class="fa fa-edit text-muted"
                                            style="pointer-events: none; opacity: 0.5;"
                                            title="Reassign final not available"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="COTeacher" class="table-responsive table-container">
                        <span>Central Observer</span>
                        <br>
                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th class="f600 text-center" width="5%"> Action </th>
                                    <th class="f600 text-center" width="5%"> Examiner Name </th>
                                    <th class="f600 text-left" width="20%"> Designation </th>
                                    <th class="f600 text-left" width="20%"> UG Experience </th>
                                    <th class="f600 text-left" width="20%"> PG Experience </th>
                                    <th class="f600 text-left" width="20%"> Is HOD </th>
                                    <th class="f600 text-left" width="20%"> Availability </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="COTeachersArray">
                                <tr *ngFor="let subject of getControlsCOTeacher(); let i = index " [formGroupName]="i"
                                    [ngClass]="{ 'red-row': (subject.get('Availability').value || '').trim().toLowerCase() === 'no',
                                'blue-row': !(subject.get('Availability').value || '').trim() }">
                                    <td class="text-center">
                                        <mat-checkbox id="{{subject.value.TeacherId}}"
                                            [formControl]="subject.get('teachercheckbox')"
                                            (change)="onCheckboxChangeInt(i)">
                                        </mat-checkbox>
                                    </td>
                                    <td class="text-left">{{ subject.get('TeacherName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Designation').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('UGExperience').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('PGExperience').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('HOD').value === true ||
                                        subject.get('HOD').value === 'true' ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Availability').value || 'Not Respond' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="CITeacher" class="table-responsive table-container">
                        <span>Central InCharge</span>
                        <br>
                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th class="f600 text-center" width="5%"> Action </th>
                                    <th class="f600 text-center" width="5%"> Examiner Name </th>
                                    <th class="f600 text-left" width="20%"> Designation </th>
                                    <th class="f600 text-left" width="20%"> UG Experience </th>
                                    <th class="f600 text-left" width="20%"> PG Experience </th>
                                    <th class="f600 text-left" width="20%"> Is HOD </th>
                                    <th class="f600 text-left" width="20%"> Availability </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="CITeachersArray">
                                <tr *ngFor="let subject of getControlsCITeachers(); let i = index " [formGroupName]="i"
                                    [ngClass]="{ 'red-row': (subject.get('Availability').value || '').trim().toLowerCase() === 'no',
                                'blue-row': !(subject.get('Availability').value || '').trim() }">
                                    <td class="text-center">
                                        <mat-checkbox id="{{subject.value.TeacherId}}"
                                            [formControl]="subject.get('teachercheckbox')"
                                            (change)="onCheckboxChangeInt(i)">
                                        </mat-checkbox>
                                    </td>
                                    <td class="text-left">{{ subject.get('TeacherName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Designation').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('UGExperience').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('PGExperience').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('HOD').value === true ||
                                        subject.get('HOD').value === 'true' ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Availability').value || 'Not Respond' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="INVTeacher" class="table-responsive table-container">
                        <span>Invigilator </span>
                        <br>
                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th class="f600 text-center" width="5%"> Action </th>
                                    <th class="f600 text-left" width="5%"> Examiner Name </th>
                                    <th class="f600 text-left" width="20%"> Designation </th>
                                    <th class="f600 text-left" width="20%"> UG Experience </th>
                                    <th class="f600 text-left" width="20%"> PG Experience </th>
                                    <th class="f600 text-left" width="20%"> Is HOD </th>
                                    <th class="f600 text-left" width="20%"> Availability </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="INVTeachersArray">
                                <tr *ngFor="let subject of getControlsINVTeachers(); let i = index " [formGroupName]="i"
                                    [ngClass]="{ 'red-row': (subject.get('Availability').value || '').trim().toLowerCase() === 'no',
                                'blue-row': !(subject.get('Availability').value || '').trim() }">
                                    <td class="text-center">
                                        <mat-checkbox id="{{subject.value.TeacherId}}"
                                            [formControl]="subject.get('teachercheckbox')"
                                            (change)="onCheckboxChangeInt(i)">
                                        </mat-checkbox>
                                    </td>
                                    <td class="text-left">{{ subject.get('TeacherName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Designation').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('UGExperience').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('PGExperience').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('HOD').value === true ||
                                        subject.get('HOD').value === 'true' ? 'Yes' : 'No' }}
                                    </td>
                                    <td class="text-left">{{ subject.get('Availability').value || 'Not Respond' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    </form>
</div>